import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer bg-dark text-light py-1">
      <div className="container">
        <div className="text-center mt-4">
          <p>
            &copy; 2024 Delta Estate bir{" "}
            <a
              className="text-light"
              target="_blank"
              rel="noopener noreferrer"
              href="https://deltaservis.com.tr/"
            >
              <img
                className="footer-logo"
                src="https://www.ikincieltelefon.com.tr/Data/EditorFiles/site-banner/footer/I4.svg"
                alt="Delta Estate"
              />
            </a>{" "}
            kuruluşudur.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
